import { render, staticRenderFns } from "./overviewDivision.vue?vue&type=template&id=c4f2add6&scoped=true"
import script from "./overviewDivision.vue?vue&type=script&lang=js"
export * from "./overviewDivision.vue?vue&type=script&lang=js"
import style0 from "./overviewDivision.vue?vue&type=style&index=0&id=c4f2add6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f2add6",
  null
  
)

export default component.exports